export function GetSinglePageAppPath(){
    return "/clinicportal/ng/";
}

export function getBaseUrl(): string {
    const baseDomain = window.location.hostname;
    const firstDotIndex = baseDomain.indexOf('.');
    const domain = baseDomain.substring(firstDotIndex + 1);
    return (`${window.location.protocol}//${domain}${window.location.port ? `:${window.location.port}` : ""}`);
}

export function GetUrlLocation(): string {
    return `${window.location.origin}${GetSinglePageAppPath()}`;
}
